export default "__VITE_ASSET__BQtHMcTY__"